import { FC } from 'react'
import { observer } from 'mobx-react'
import styles from './index.module.scss'

export const TopPageBanner2508: FC = observer(() => {
  return (
    <div className={styles.container}>
      <div className='container'>
        <div className={styles.header}>
          <h1 className={styles.mainTitle}>Sponsored</h1>
          <p className={styles.subtitle}>American Express</p>
        </div>
        <a
          href='https://www.americanexpress.com/ja-jp/credit-cards/gold-business-corp-card/?ieep=03MC5439&sourcecode=A0000HKH9N&cpid=100600609&affid=Other'
          target='_blank'
          rel='noopener noreferrer'
          className={styles.banner}
        >
          <img
            src='/images/common/home/2508/banner.webp'
            alt='American Express Business Gold Card'
            className={styles.bannerImage}
            loading='lazy'
          />
        </a>
      </div>
    </div>
  )
})
